
















































































import {
  defineComponent, reactive, computed, ref,
} from '@vue/composition-api';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';
import { useRouter } from '@ideavivat/vivat-2';

import CommonLearningCenterTypeSelector from '@/components/Selector/CommonLearningCenterTypeSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import { ToggleButton } from 'vue-js-toggle-button';

import learningCenter from '@/table/learningCenter';
import getLearningCenterTypes from '@/gql/getLearningCenterTypes.gql';
import getLearningCenters from '@/gql/getLearningCenters.gql';
import setActiveLearningCenter from '@/gql/setActiveLearningCenter.gql';
import deleteLearningCenter from '@/gql/deleteLearningCenter.gql';
import PanelWithCopyEntity from '@/components/PanelWithCopyEntity.vue';
import i18n from '@/i18n';

const List = defineComponent({
  setup() {
    const search = reactive({
      text: '',
      type: '',
    });

    const { result: getLearningCenterTypesResult } = useQuery(getLearningCenterTypes);
    const learningCenterTypes = useResult(getLearningCenterTypesResult, {}, (data) => data.learningCenterTypes);

    // ==== Mutate Active Item ==== //
    const changeActive = reactive({
      id: undefined,
      status: false,
    });

    const activeMutation = useMutation(
      setActiveLearningCenter,
      () => ({
        variables: {
          ...changeActive,
        },
        refetchQueries: ['getLearningCenters'],
      }),
    );

    function setActiveStatus(id: any, status: boolean) {
      changeActive.id = id;
      changeActive.status = status;
      activeMutation.mutate();
    }
    // ============================= //

    // ==== Set message to display on delete dialog ==== //
    const deleteItem = reactive({
      id: '',
      name: '',
    });
    function setDisplayItem(item: any) {
      deleteItem.id = item.id;
      deleteItem.name = item.name;
    }
    // ==== Create delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteLearningCenter,
      () => ({
        variables: {
          id: deleteItem.id,
        },
        refetchQueries: ['getLearningCenters'],
      }),
    );

    // ==== Redirect to view item page ==== //
    const { router } = useRouter();
    function viewItem(item: any) {
      router.push({ name: 'LearningCenterView', params: { learningCenterId: item.item?.id } });
    }

    // ==== Use to search Learning Center ==== //
    const learningCenterListVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filterLearningCenterType: undefined,
        searchName: undefined,
      };
      if (search.text) {
        vars.searchName = `%${search.text}%`;
      }
      if (search.type) {
        vars.filterLearningCenterType = parseInt(search.type, 10);
      }
      return vars;
    });

    const copyingItem = ref({});

    return {
      copyingItem,
      learningCenterOption: learningCenter,
      getLearningCenterQuery: getLearningCenters,
      learningCentersResult: (data: any) => data.learningCenters,
      search,
      learningCenterTypes,
      setActiveStatus,
      deleteItem,
      setDisplayItem,
      deleteMutation,
      learningCenterListVariables,
      viewItem,
      i18n,
    };
  },
  components: {
    PanelWithCopyEntity,
    CommonLearningCenterTypeSelector,
    CommonConfirmDialog,
    ToggleButton,
  },
  props: {
    role: {},
  },
});

export default List;
